var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg58(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_2594)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_2594)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 6H14C11.7909 6 10 7.79086 10 10V28C10 30.2091 11.7909 32 14 32H32C34.2091 32 36 30.2091 36 28V10C36 7.79086 34.2091 6 32 6Z",
    fill: "#A92C2C"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M32.0001 2H14.0001C11.791 2 10.0001 3.79086 10.0001 6V24C10.0001 26.2091 11.791 28 14.0001 28H32.0001C34.2092 28 36.0001 26.2091 36.0001 24V6C36.0001 3.79086 34.2092 2 32.0001 2Z",
    fill: "#F13838"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5241 20.15C18.7241 20.15 18.1141 19.925 17.6941 19.475C17.2741 19.015 17.0641 18.36 17.0641 17.51V16.685H18.6241V17.63C18.6241 18.31 18.9091 18.65 19.4791 18.65C20.0491 18.65 20.3341 18.31 20.3341 17.63V15.275C20.3341 14.585 20.0491 14.24 19.4791 14.24C18.9091 14.24 18.6241 14.585 18.6241 15.275V15.365H17.0641L17.3641 9.5H21.7141V11H18.8341L18.6991 13.505H18.7291C19.0391 12.995 19.5141 12.74 20.1541 12.74C20.7541 12.74 21.2091 12.945 21.5191 13.355C21.8291 13.765 21.9841 14.36 21.9841 15.14V17.51C21.9841 18.36 21.7741 19.015 21.3541 19.475C20.9341 19.925 20.3241 20.15 19.5241 20.15ZM25.5 20.15C24.67 20.15 24.03 19.93 23.58 19.49C23.14 19.04 22.92 18.395 22.92 17.555V16.625C22.92 16.105 23.005 15.67 23.175 15.32C23.345 14.96 23.62 14.68 24 14.48V14.45C23.65 14.26 23.39 14 23.22 13.67C23.06 13.33 22.98 12.9 22.98 12.38V11.945C22.98 11.105 23.195 10.465 23.625 10.025C24.065 9.575 24.69 9.35 25.5 9.35C26.31 9.35 26.93 9.575 27.36 10.025C27.8 10.465 28.02 11.105 28.02 11.945V12.38C28.02 13.38 27.68 14.07 27 14.45V14.48C27.38 14.68 27.655 14.96 27.825 15.32C27.995 15.67 28.08 16.105 28.08 16.625V17.555C28.08 18.395 27.855 19.04 27.405 19.49C26.965 19.93 26.33 20.15 25.5 20.15ZM25.5 13.775C26.08 13.775 26.37 13.425 26.37 12.725V11.9C26.37 11.2 26.08 10.85 25.5 10.85C24.92 10.85 24.63 11.2 24.63 11.9V12.725C24.63 13.425 24.92 13.775 25.5 13.775ZM25.5 18.65C26.12 18.65 26.43 18.255 26.43 17.465V16.46C26.43 15.67 26.12 15.275 25.5 15.275C24.88 15.275 24.57 15.67 24.57 16.46V17.465C24.57 18.255 24.88 18.65 25.5 18.65Z",
    fill: "#111820"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_2594",
    x: 0,
    y: 0,
    width: 46,
    height: 46,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_2594"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_2594",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2594"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg58);
export default __webpack_public_path__ + "static/media/58.b4d8a5e2f5177e89189bec42cf640270.svg";
export { ForwardRef as ReactComponent };